import Api from "lib/Api";

export function fetchReports() {
  return () => {
    return Api.getCollection("reports", `/reports`);
  };
}
